// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductCategoryPage_wrapper__zYWAT"};